import React from "react";

import { emailRegEx, urlRegEx } from "base/form";

export function handleLink(value = "") {
  const val = value ? String(value) : "";

  let href = "";
  let linkComponent = null;

  if (val.match(emailRegEx)) {
    href = `mailto:${val}`;
  } else if (val.match(urlRegEx)) {
    href = val;
  }

  if (href) {
    linkComponent = (
      <a
        className="text-link"
        target="_blank"
        onClick={(e) => {
          e.stopPropagation();
        }}
        href={href}
        rel="noopener noreferrer"
      >
        {val}
      </a>
    );
  }

  return linkComponent;
}
